import { Search } from "lucide-react";
import React from "react";

interface EmptyStateProps {
  searchQuery: string;
  showNoResults: boolean;
  showDefault: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  searchQuery,
  showNoResults,
  showDefault,
}) => {
  // Show no results state
  if (showNoResults) {
    return (
      <div className="flex flex-col items-center justify-center px-4 py-14">
        <div className="mb-4 rounded-full bg-muted p-3">
          <Search className="h-6 w-6 text-muted-foreground" />
        </div>
        <p className="text-sm font-medium text-foreground">No results found</p>
        <p className="mt-1 text-xs text-muted-foreground">
          We couldn't find anything matching "{searchQuery}"
        </p>
        <div className="mt-4 flex flex-col gap-1 text-xs text-muted-foreground">
          <p>Try:</p>
          <ul className="ml-4 list-disc text-left">
            <li>Checking your spelling</li>
            <li>Using different keywords</li>
            <li>Searching for partial names</li>
          </ul>
        </div>
      </div>
    );
  }

  // Show default empty state
  if (showDefault) {
    return (
      <div className="flex flex-col px-4 py-3">
        {/* Keyboard Shortcuts */}
        <div className="flex items-center justify-center gap-4 border-t pt-4">
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <kbd className="rounded border bg-muted px-1.5 py-0.5 font-mono text-[10px] font-medium">
              ↑↓
            </kbd>
            <span>Navigate</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <kbd className="rounded border bg-muted px-1.5 py-0.5 font-mono text-[10px] font-medium">
              ↵
            </kbd>
            <span>Select</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <kbd className="rounded border bg-muted px-1.5 py-0.5 font-mono text-[10px] font-medium">
              ESC
            </kbd>
            <span>Close</span>
          </div>
        </div>
      </div>
    );
  }

  return null;
};
